import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { Result } from "../../../types/Result";

interface IProps {
    show: boolean
    onHide: (departmentId?: number) => void
}

interface CreateModel {
    name: string
    managerEmployeeId: number
}

const CreateDepartmentPopup: React.FC<IProps> = ({ show, onHide }) => {
    const employees = useSelectListOptions('api/v1/selectlist/Employees', '-- Select manager');
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<CreateModel>({
        name: '',
        managerEmployeeId: 0,
    });

    function submit() {
        if (formData) {
            DataService
                .create<number>(`api/v1/Departments`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide(response.data);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        formData[name] = value;
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Name', validationRules: [{ type: 'isRequired' }, { type: 'isMaxLength', maxLength:50 }] },
            { name: 'managerEmployeeId', label: 'Manager', validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Create department'} >
            <Popup.Body>
                <TextboxField {...getFieldProps('name')} />
                <SelectListField {...getFieldProps('managerEmployeeId')} options={employees} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Create' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default CreateDepartmentPopup;